// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fksRf","toggleWrap":"styles_toggleWrap__6SzU0","content":"styles_content__wkm4p","selectAreaCode":"styles_selectAreaCode__HfCzY"};